import { IMAGES } from "./site";

export const PRODUCTS = [
  {
    slug: "aluminium-windows",
    name: "Aluminium Windows",
    category: "Residential",
    tagline: "Slim sightlines. Maximum glass. Fabricated in Romford.",
    image: IMAGES.residentialSemi,
    alt: "UK semi-detached home with new anthracite grey aluminium windows fabricated by Empire Aluminium Windows Romford",
    description:
      "Our aluminium windows are fabricated in-house at our Romford factory on proven Exlabesa and Comar systems. Slim sightlines, exceptional thermal performance and powder coated in any RAL colour — supplied direct to trade or fully installed.",
    features: [
      "Thermally broken polyamide profiles",
      "U-values as low as 0.94 W/m²K (Comar 5P.i)",
      "Any RAL colour — powder coated in-house",
      "Dual colour options (inside/outside)",
      "17mm–62mm glazing options",
      "Multi-point locking as standard",
    ],
    systems: [
      { brand: "exlabesa", name: "Exlabesa Window Systems", spec: "Cost-effective residential casement and tilt-turn profiles with excellent thermal performance — the smart choice for homes and refurbs." },
      { brand: "comar", name: "Comar 5P.i Advanced", spec: "Premium slim-sightline windows, thermally broken to U-values as low as 0.94 W/m²K, glazing 17–62mm." },
    ],
    specs: { "Frame depth": "70mm", "Max sash size": "1,500 x 2,400mm", "Glazing": "Double / Triple", "Lead time": "5–10 working days" },
    seoTitle: "Aluminium Windows Romford | Empire Aluminium Windows",
    seoDescription:
      "Premium aluminium windows made in our Romford factory. Slim frames, any RAL colour, fast lead times. Trade supply or installed, London and nearby areas.",
  },
  {
    slug: "casement-windows",
    name: "Casement Windows",
    category: "Residential",
    tagline: "The UK's most popular window, engineered better.",
    image: IMAGES.casement,
    alt: "Anthracite grey aluminium casement windows on a modern brick home",
    description:
      "Flush and standard aluminium casement windows built to order in our factory on cost-effective Exlabesa residential systems. Crisp square-cut frames, multi-point locking and colour-matched hardware — the tradesman's go-to casement, at trade prices with no middleman.",
    features: [
      "Flush or standard casement styles",
      "Multi-point espagnolette locking",
      "Concealed friction hinges",
      "Trickle vent options built in",
      "Any RAL colour or dual colour",
      "Fully welded or mechanical joints",
    ],
    systems: [
      { brand: "exlabesa", name: "Exlabesa Casement Systems", spec: "High-performance residential casements at cost-effective prices — great U-values without the premium price tag." },
    ],
    specs: { "Frame depth": "60–70mm", "Opening styles": "Top hung / Side hung / Fixed", "Glazing": "Double / Triple", "Lead time": "5–10 working days" },
    seoTitle: "Aluminium Casement Windows | Empire Aluminium Windows",
    seoDescription:
      "Aluminium casement windows made factory-direct in Romford. Flush options, any RAL colour, trade prices, fast turnaround. London and the surrounding areas.",
  },
  {
    slug: "sash-windows",
    name: "Sash Windows",
    category: "Residential",
    tagline: "Period elegance with modern aluminium performance.",
    image: IMAGES.sash,
    alt: "White aluminium vertical sliding sash windows on a Victorian terrace house in London",
    description:
      "Vertical sliding aluminium sash windows that replicate traditional timber box sashes with none of the maintenance. Perfect for period properties, conservation-conscious refurbishments and heritage-style new builds.",
    features: [
      "Authentic vertical sliding action",
      "Spiral or spring balance mechanisms",
      "Georgian bar and heritage detailing",
      "Tilt-in sashes for easy cleaning",
      "Woodgrain and heritage colour finishes",
      "Draught-sealed for modern efficiency",
    ],
    specs: { "Frame depth": "125mm box", "Max size": "1,200 x 2,700mm", "Glazing": "Double glazed 24mm", "Lead time": "10–15 working days" },
    seoTitle: "Aluminium Sash Windows | Empire Aluminium Windows",
    seoDescription:
      "Aluminium vertical sliding sash windows made in Romford. Heritage looks, modern thermal performance, any colour. Trade supply or fully installed.",
  },
  {
    slug: "aluminium-doors",
    name: "Aluminium Doors",
    category: "Residential",
    tagline: "Residential, French and sliding doors built to last.",
    image: IMAGES.glassFront,
    alt: "Large glazed aluminium doors on a contemporary home extension",
    description:
      "From single residential doors to expansive lift-slide systems, every aluminium door is fabricated to millimetre precision in our factory on Exlabesa and Comar systems. High security, effortless operation and finished in any colour you can name.",
    features: [
      "Residential, French & sliding systems",
      "Multi-point locking options",
      "High-traffic hinges and hardware",
      "Low thresholds for level access",
      "Slimline interlocks on sliders",
      "Panoramic glass-to-glass corners",
    ],
    systems: [
      { brand: "exlabesa", name: "Exlabesa Entrance & Sliding Doors", spec: "Residential entrance doors and sliding systems — strong performance at cost-effective prices." },
      { brand: "comar", name: "Comar 7P.i LS+ Lift-Slide", spec: "Panoramic lift-slide door with U-values down to 0.74 W/m²K with thermal foam and triple glazing." },
    ],
    specs: { "Max panel height": "2,700mm", "Threshold": "Low / Rebated", "Glazing": "28–50mm units", "Lead time": "7–12 working days" },
    seoTitle: "Aluminium Doors Romford | Empire Aluminium Windows",
    seoDescription:
      "Aluminium entrance, French and sliding doors made factory-direct in Romford. Trade supply and installation, London and the surrounding areas.",
  },
  {
    slug: "bifold-doors",
    name: "Bifold Doors",
    category: "Residential",
    tagline: "Open up entire walls. Fabricated in days, not weeks.",
    image: IMAGES.heroBifold,
    alt: "Aluminium bifold doors fully opened connecting a modern kitchen to the garden",
    description:
      "Our best-selling product. Aluminium bifold doors with ultra-slim sightlines, smooth-glide running gear and configurations up to 7 panels. Fabricated in-house on Exlabesa and Comar folding systems, which is why our lead times beat every merchant in the South East.",
    features: [
      "2 to 7 panel configurations",
      "Sightlines from just 120mm",
      "Stainless steel rollers — lifetime smooth",
      "Traffic door options for daily use",
      "Weathertight to 600Pa",
      "Any RAL colour, matt or gloss",
    ],
    systems: [
      { brand: "exlabesa", name: "Exlabesa Bi-folding Doors", spec: "Smooth-glide residential bifolds combining performance and cost-effective pricing." },
      { brand: "comar", name: "Comar 7P.i FSD Bi-fold", spec: "Premium folding sliding door achieving U-values down to 0.97 W/m²K triple glazed." },
    ],
    specs: { "Max panel width": "1,200mm", "Max height": "2,500mm", "Panels": "2–7", "Lead time": "7–10 working days" },
    seoTitle: "Aluminium Bifold Doors | Empire Aluminium Windows",
    seoDescription:
      "Aluminium bifold doors made in our Romford factory. Slim sightlines, fast lead times, factory-direct prices. Supply only or installed.",
  },
  {
    slug: "internal-partitions",
    name: "Internal Partitions",
    category: "Internal",
    tagline: "Divide space. Keep the light. Crittall-style precision.",
    image: IMAGES.partitions,
    alt: "Black aluminium framed glass internal partition dividing a modern open plan living space",
    description:
      "Slim-framed aluminium glass partitions that zone open-plan spaces without losing light. Popular in homes, offices and retail fit-outs — every screen is made to measure in our factory with fixed, hinged or sliding sections.",
    features: [
      "Crittall-style grid detailing",
      "Fixed screens, doors & sliders",
      "Toughened safety glass throughout",
      "Acoustic glazing options",
      "Matt black, bronze or any RAL",
      "Made to measure — no stock sizes",
    ],
    specs: { "Frame profile": "25–40mm", "Max height": "3,000mm", "Glass": "6.8–10.8mm toughened/laminated", "Lead time": "7–12 working days" },
    seoTitle: "Internal Glass Partitions | Empire Aluminium Windows",
    seoDescription:
      "Bespoke aluminium glass partitions made in Romford. Crittall-style screens and doors for homes, offices and retail. Trade supply or installed.",
  },
  {
    slug: "sleek-internal-doors",
    name: "Sleek Internal Doors",
    category: "Internal",
    tagline: "Minimal frames. Maximum design impact.",
    image: IMAGES.internalDoors,
    alt: "Sleek black aluminium framed glass internal double doors in a luxury home",
    description:
      "Ultra-slim aluminium internal doors that architects love. Single, double, pivot and pocket configurations with near-invisible frames — fabricated with the same factory precision as our external systems.",
    features: [
      "Sightlines from 20mm",
      "Single, double, pivot & pocket",
      "Soft-close hardware options",
      "Clear, fluted or smoked glass",
      "Concealed hinges",
      "Frameless-look thresholds",
    ],
    specs: { "Frame profile": "20–35mm", "Max door height": "2,700mm", "Glass": "Toughened 8mm", "Lead time": "7–12 working days" },
    seoTitle: "Sleek Internal Aluminium Doors | Empire Aluminium Windows",
    seoDescription:
      "Slim-frame aluminium internal glass doors made in our Romford factory. Pivot, double and pocket options. Factory-direct prices for trade and homeowners.",
  },
  {
    slug: "arched-doors",
    name: "Arched Doors",
    category: "Internal",
    tagline: "Statement curves, engineered in aluminium.",
    image: IMAGES.archedDoors,
    alt: "Elegant arched black aluminium framed glass door on a luxury rendered home",
    description:
      "True curved-head aluminium doors and screens — a signature Empire capability few fabricators offer. Each arch is rolled, welded and finished in-house for interiors and entrances that demand something extraordinary.",
    features: [
      "True rolled arches — not faceted",
      "Internal & external systems",
      "Matching arched sidelights & screens",
      "Toughened curved-head glazing",
      "Any RAL colour finish",
      "CAD drawings approved before fabrication",
    ],
    specs: { "Max arch width": "2,400mm", "Max height": "3,000mm", "Glass": "Toughened / laminated", "Lead time": "15–20 working days" },
    seoTitle: "Arched Aluminium Doors | Empire Aluminium Windows",
    seoDescription:
      "Bespoke arched aluminium doors rolled and fabricated in-house in Romford. True curves, any colour, trade supply or full installation across the UK.",
  },
  {
    slug: "commercial-windows",
    name: "Commercial Windows",
    category: "Commercial",
    tagline: "Comar & Senior systems, fabricated to programme.",
    image: IMAGES.commercialWindows,
    alt: "Grey aluminium commercial windows on a modern UK office building fabricated on Comar and Senior systems",
    description:
      "Commercial aluminium windows fabricated on the two systems specifiers ask for by name: Comar 5P.i Advanced and Senior's SPW and PURe ranges. Premium quality, top-of-the-line thermal performance and the fast, reliable programme delivery contractors need on commercial projects.",
    features: [
      "Comar 5P.i Advanced — U-values to 0.94 W/m²K",
      "Senior PURe patented thermal barrier",
      "Tilt-turn, casement & fixed-light configurations",
      "BS 6375 weather tested",
      "Ribbon glazing & framing integration",
      "Any RAL colour, coated in-house",
    ],
    systems: [
      { brand: "comar", name: "Comar 5P.i Advanced Windows", spec: "Slim sightlines, thermally broken to U-values as low as 0.94 W/m²K, glazing 17–62mm, integrates with 7P.i and 9P.i doors." },
      { brand: "senior", name: "Senior SPW501 Framing & Windows", spec: "Thermally broken framing for high pedestrian use with flush-glazed mullions — the commercial workhorse." },
      { brand: "senior", name: "Senior PURe Windows", spec: "Patented expanded polyurethane thermal core delivering outstanding U-values for high-spec projects." },
    ],
    specs: { "Systems": "Comar 5P.i / Senior SPW & PURe", "Glazing": "17–62mm", "Testing": "BS 6375", "Lead time": "10–15 working days" },
    seoTitle: "Commercial Aluminium Windows | Empire Aluminium Windows",
    seoDescription:
      "Commercial aluminium windows fabricated in Romford on Comar 5P.i and Senior SPW/PURe systems. Low U-values and fast lead times for contractors.",
  },
  {
    slug: "curtain-walling",
    name: "Curtain Walling",
    category: "Curtain Walling",
    tagline: "Comar 6EFT & Senior SF52 — fabricated and delivered on programme.",
    image: IMAGES.curtainWalling,
    alt: "Aluminium curtain walling facade on a modern UK city centre office building",
    description:
      "Full curtain walling packages fabricated on Comar 6EFT and Senior SF52 — the systems commercial specifiers trust for premium quality and top-of-the-line performance. Capped, silicone-glazed and mullion-drained options, engineered, fabricated and coated under one roof in Romford.",
    features: [
      "Comar 6EFT — 50mm thermally broken profile",
      "Senior SF52 — 52mm sightlines",
      "Capped, 2-sided & 4-sided structural silicone glazing",
      "Sloped, pitched & pyramid roof glazing",
      "CWCT & EN 13830 weather tested",
      "Integrates with Comar/Senior windows & doors",
    ],
    systems: [
      { brand: "comar", name: "Comar 6EFT Curtain Walling", spec: "Thermally broken 50mm profile; capped, two-sided and four-sided structural silicone glazing; sloped, pitched and pyramid roof glazing; integrates with 5P.i windows and 7P.i/9P.i doors." },
      { brand: "senior", name: "Senior SF52 Curtain Walling", spec: "Consistent 52mm sightlines; fully capped, silicone-glazed, vertical/horizontal capped and mullion-drained options; glazing 6–50mm; CWCT & EN 13830 tested — 600Pa air & water, 2400Pa wind resistance." },
    ],
    specs: { "Systems": "Comar 6EFT / Senior SF52", "Sightlines": "50–52mm", "Glazing": "6–50mm", "Lead time": "15–20 working days" },
    seoTitle: "Aluminium Curtain Walling | Empire Aluminium Windows",
    seoDescription:
      "Curtain walling fabricated in Romford on Comar 6EFT and Senior SF52 systems. CWCT tested, structural silicone options, supply only or installed.",
  },
  {
    slug: "shopfronts",
    name: "Shopfronts",
    category: "Commercial",
    tagline: "High street presence, fabricated and fitted fast.",
    image: IMAGES.shopfront,
    alt: "Modern aluminium shopfront with full height glazing on a UK high street",
    description:
      "Complete aluminium shopfront systems for retail, hospitality and office frontages. Toughened glazing, integrated signage bands and heavy-duty entrance doors — measured, fabricated and delivered on schedules that keep your fit-out on programme.",
    features: [
      "Full-height toughened glazing",
      "Integrated fascia & signage sections",
      "Manual & automatic entrance doors",
      "Anti-vandal & laminated glass options",
      "Night vents & transom lights",
      "Site survey to installation service",
    ],
    specs: { "Profile system": "45–50mm commercial", "Max height": "4,000mm", "Glass": "Toughened / laminated to spec", "Lead time": "10–15 working days" },
    seoTitle: "Aluminium Shopfronts London | Empire Aluminium Windows",
    seoDescription:
      "Aluminium shopfronts fabricated in Romford and installed across London and the surrounding areas. Full-height glazing, signage, fast lead times.",
  },
  {
    slug: "commercial-doors",
    name: "Commercial Aluminium Doors",
    category: "Commercial",
    tagline: "Comar 7P.i & Senior SPD150 — built for thousands of cycles a day.",
    image: IMAGES.commercialDoors,
    alt: "Heavy duty commercial aluminium double entrance doors at a modern office building",
    description:
      "Heavy-duty commercial aluminium doors fabricated on Comar 7P.i CD and Senior SPD150 — premium systems engineered for schools, offices, retail and public buildings. Reinforced corners, heavy-traffic pivots and DDA-compliant thresholds as standard.",
    features: [
      "Comar 7P.i CD — anti-finger-trap stiles",
      "Senior SPD150 — leaf weights to 150kg",
      "DDA-compliant low thresholds",
      "Heavy-duty floor springs & closers",
      "Access control ready",
      "Toughened & laminated glazing",
    ],
    systems: [
      { brand: "comar", name: "Comar 7P.i CD Commercial Door", spec: "Robust high-traffic swing door with anti-finger-trap stiles, tested to BS 6375." },
      { brand: "senior", name: "Senior SPD150 Door", spec: "High-usage thermally broken door — U-values from 1.3 W/m²K, glazing 28–48mm, leaf weights to 150kg." },
      { brand: "senior", name: "Senior PURe Commercial Door", spec: "Patented expanded polyurethane thermal core for exceptional efficiency on high-spec commercial projects." },
    ],
    specs: { "Systems": "Comar 7P.i CD / Senior SPD150 & PURe", "Max leaf": "1,250 x 2,600mm · 150kg", "Cycles": "High-usage tested", "Lead time": "10–15 working days" },
    seoTitle: "Commercial Aluminium Doors | Empire Aluminium Windows",
    seoDescription:
      "Heavy-duty commercial aluminium doors fabricated in Romford on Comar 7P.i CD and Senior SPD150. DDA compliant, access-control ready, fast lead times.",
  },
  {
    slug: "panic-bar-doors",
    name: "Panic Bar Doors",
    category: "Commercial",
    tagline: "Certified emergency exits with concealed panic hardware.",
    image: IMAGES.panicExitDoor,
    alt: "Commercial aluminium fire exit door fitted with a fully concealed rod soft touch panic exit device in a UK office",
    description:
      "EN 1125 certified aluminium panic bar doors for emergency escape routes, supplied with Axim hardware including the PR7100 fully concealed rod soft-touch panic exit device. Push-bar, touch-bar and paddle options, outside access devices and full compliance documentation — supplied direct to contractors nationwide.",
    features: [
      "Axim PR7100 fully concealed rod soft-touch device",
      "PR7085 concealed rod crash bar option",
      "Rim-mounted crash bar & paddle alternatives",
      "Outside access devices & locking handles",
      "Full ironmongery options: floor springs, transom closers, pull handles, deadlatches, electric strikes & flush bolts",
      "Full compliance documentation supplied",
    ],
    systems: [
      { brand: null, name: "Axim PR7100 Concealed Rod Soft Touch", spec: "Fully concealed vertical rod soft-touch panic exit device — sleek full-width touch bar with no visible rods, EN 1125 certified." },
      { brand: null, name: "Axim PR7085 / PR7095 Series", spec: "Concealed rod and rim-mounted crash bar and paddle exit devices for single and double rebated doors." },
      { brand: null, name: "Complete Ironmongery Range", spec: "FS floor springs, TC concealed transom closers, HD pull handles, LK deadlatches, ES electric strikes and FB flush bolts — specified and fitted to your door schedule." },
    ],
    specs: { "Certification": "EN 1125 / EN 179", "Max leaf": "1,200 x 2,500mm", "Hardware": "Axim PR7100 / PR7085 / PR7095", "Lead time": "10–15 working days" },
    seoTitle: "Aluminium Panic Bar Doors | Empire Aluminium Windows",
    seoDescription:
      "EN 1125 certified aluminium panic bar doors with Axim concealed-rod exit devices. Full ironmongery options, fabricated in Romford, supplied UK-wide.",
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const CATEGORIES = ["All", "Residential", "Internal", "Commercial", "Curtain Walling"];
